import React, { useMemo, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const services = [
  { id: 'intake', label: '90791 Intake Session', price: 205.0 },
  { id: 'therapy-38-52', label: '90834 (38-52 min) Therapy Session', price: 125.0 },
  { id: 'therapy-53-plus', label: '90837 (53+ min) Therapy Session', price: 175.0 },
  { id: 'couples-family', label: '90846/90847 Couples/Family Therapy Session', price: 175.0 },
  { id: 'crisis', label: '90839 Therapy for Crisis', price: 175.0 },
];

const Estimate = () => {
  const [quantities, setQuantities] = useState(() => services.map(() => 0));
  const quantityOptions = useMemo(() => Array.from({ length: 61 }, (_, index) => index), []);

  const handleQuantityChange = (serviceIndex) => (event) => {
    const value = Number(event.target.value);
    setQuantities((prev) => {
      const next = [...prev];
      next[serviceIndex] = Number.isNaN(value) ? 0 : value;
      return next;
    });
  };

  const total = services.reduce((sum, service, index) => sum + service.price * quantities[index], 0);

  return (
    <>
      <section className="estimate-intro">
        <div className="estimate-intro-card">
          <div className="estimate-intro-header text-center">
            <h1>Good Faith Estimate</h1>
            <p>You have the right to receive a “Good Faith Estimate” explaining how much your medical care will cost.</p>
          </div>
          <div className="estimate-intro-body">
            <div className="estimate-intro-left">
              <p>
                How long you need to engage in therapy and how often you attend sessions will be influenced by many
                factors.
              </p>
            </div>
            <div className="estimate-intro-right">
              <p>
                Under the law, health care providers need to give patients who don’t have insurance or who are not using
                insurance an estimate of the bill for medical items and services. The Good Faith Estimate’s purpose is to
                show the cost of services to avoid an unreasonably large bill. Your treatment and cost of treatment will
                vary based on your individual needs, amount of therapy sessions, and the type and length of sessions you
                attend.
              </p>
              <p>
                There is no way of predicting the exact amount of therapy sessions or services that will be needed;
                however, this online calculator is available to you and please remember you can always discuss billing,
                cost, treatment plan, length of sessions, and amount of sessions at any time with your therapist.
              </p>
            </div>
          </div>
          <p className="estimate-intro-footer text-center">
            Below is a list of the top 5 procedures at Hope Road and their associated costs. I look forward to talking
            with you and answering any questions you may have about the “No Surprises” Act and Good Faith Estimates.
          </p>
        </div>
      </section>

      <section className="section">
        <Container>
          <Row>
            <Col md={12}>
            <h2>Estimate Your Needs</h2>
            <h3 className="mt-4">Good Faith Estimate (GFE)</h3>
            <p className="text-muted">
              Select the number of visits you anticipate for each service type to view an estimated cost. This tool is
              for informational purposes only and does not replace a formal quote.
            </p>
            <table className="table mt-3">
              <thead>
                <tr>
                  <th scope="col">Service</th>
                  <th scope="col">Price</th>
                  <th scope="col" className="text-end">Quantity</th>
                </tr>
              </thead>
              <tbody>
                {services.map((service, index) => (
                  <tr key={service.id}>
                    <td>{service.label}</td>
                    <td>${service.price.toFixed(2)}</td>
                    <td className="text-end" style={{ maxWidth: '120px' }}>
                      <select
                        className="form-control"
                        value={quantities[index]}
                        onChange={handleQuantityChange(index)}
                      >
                        {quantityOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="mt-3 fs-5">
              <strong>Total Estimated Cost: </strong>${total.toFixed(2)}
            </p>
          </Col>
        </Row>
        
        </Container>
      </section>
    </>
  );
};

export default Estimate;
